<div class="payment-method-selector-modal">
  @if (data && data.data && data.data.match && data.data.match.customer) {
    <div class="modal-info">
      <mat-icon>info</mat-icon>
      <p>Select a payment method for <strong>{{ data.data.match.customer.displayName || data.data.match.customer.companyName || 'this customer' }}</strong></p>
    </div>
  }

  @if (data && data.data && data.data.paymentMethods && data.data.paymentMethods.length === 0) {
    <div class="no-methods">
      <mat-icon>warning</mat-icon>
      <p>No payment methods found for this customer.</p>
      <p class="hint">The customer needs to add a payment method before you can process this payment.</p>
    </div>
  } @else if (data && data.data && data.data.paymentMethods) {
    <mat-radio-group [(ngModel)]="selectedPaymentMethod" class="payment-method-group">
      @if (cardPaymentMethods.length > 0) {
        <div class="method-section">
          <h4>Credit/Debit Cards</h4>
          @for (method of cardPaymentMethods; track method.id) {
            <mat-radio-button [value]="method" class="payment-method-option">
              <div class="method-details">
                <mat-icon class="method-icon">{{ getPaymentMethodIcon(method) }}</mat-icon>
                <div class="method-info">
                  <span class="method-label">{{ getPaymentMethodDisplay(method) }}</span>
                  @if (method.isDefault) {
                    <span class="default-badge">
                      <mat-icon>star</mat-icon>
                      Default
                    </span>
                  }
                  @if (method.cardFunding) {
                    <span class="funding-type">{{ method.cardFunding }}</span>
                  }
                </div>
              </div>
            </mat-radio-button>
          }
        </div>
      }

      @if (achPaymentMethods.length > 0) {
        <div class="method-section">
          <h4>ACH / Bank Accounts</h4>
          @for (method of achPaymentMethods; track method.id) {
            <mat-radio-button [value]="method" class="payment-method-option">
              <div class="method-details">
                <mat-icon class="method-icon">{{ getPaymentMethodIcon(method) }}</mat-icon>
                <div class="method-info">
                  <span class="method-label">{{ getPaymentMethodDisplay(method) }}</span>
                  @if (method.isDefault) {
                    <span class="default-badge">
                      <mat-icon>star</mat-icon>
                      Default
                    </span>
                  }
                </div>
              </div>
            </mat-radio-button>
          }
        </div>
      }
    </mat-radio-group>
  }
</div>



